// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2kBXr","placeholdersHeader":"styles_placeholdersHeader__1oS58","editorStyle":"styles_editorStyle__11EwR","placeholdersBox":"styles_placeholdersBox__kVbnY"};